import { GroupParticipant, NineBoxGroupParticipant } from 'src/app/calibration/_interfaces/group-participant.interface';
import { CalibrationType, NineBoxRatings } from 'src/app/calibration/_interfaces/ratings-data.interface';
import { AxiConfiguration } from 'src/app/calibration/components/calibration-nine-box/models/axi.model';
import { GroupUser } from './group-user.interface';

export interface Group {
	cycleId: number;
	processId: number;
	name: string;
	participantsQty: number;
    participantsQtyVisible?: number;
    participantsQtyBlocked?: number;
	year?: number;
    participantsName?: string[];
	createdAt: Date;
	meetingInProgress?: boolean;
	hasThreeSixty?: boolean;
	type: GroupTypeEnum;

	groupId?: number;
	notes?: string;
	userIds?: Array<string>;
	users?: Array<GroupUser>;
	sharedWith?: Array<GroupUser>;
	sharedBy?: GroupUser;
	calibrationType?: CalibrationType;
}

export interface CalibrationGroup extends Group {
	updatedAt: string;
	participants: GroupParticipant[];
	calibrationType: CalibrationType;
}

export interface NineBoxCalibrationGroup extends CalibrationGroup {
	participants: NineBoxGroupParticipant[];
	nineBoxConfig: AxiConfiguration;
	nineBoxRatings: NineBoxRatings;
    canEdit?: boolean;
}

export enum GroupTypeEnum {
	Visualization = 1,
	Meeting = 2
}
